<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-card-title>
            <div class="headline">{{ heading }}</div>
            <v-spacer></v-spacer>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.value1 }}</td>
                  <td class="text-xs-left">{{ row.item.value2 }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item.value1)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  props: {
    helpListID: String,
    busCls: String
  },
  data() {
    return {
      headers: [],
      title: '',
      heading: '',
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    helpListID: function (value) {
      this.getHeaders()
      this.doInit()
    }
  },
  created() {
    this.getHeaders()
    this.doInit()
  },
  methods: {
    getHeaders() {
      this.headers = []
      let IdHeader = {}
      if (this.helpListID === 'busClsGrpList') {
        IdHeader = {
          text: 'Business Class Code',
          value: 'value1'
        }
        this.title = 'Business Class Group Helplist'
        this.heading = 'Business Class Groups List'
      } else if (this.helpListID === 'glanCodeList') {
        IdHeader = {
          text: 'Glan Code',
          value: 'value1'
        }
        this.title = 'Glan Code Helplist'
        this.heading = 'Glan Codes List'
      } else if (this.helpListID === 'accumTypeList') {
        IdHeader = {
          text: 'Accumulation Type',
          value: 'value1'
        }
        this.title = 'Accumulation Type Helplist'
        this.heading = 'Accumulation Types List'
      } else if (this.helpListID === 'vehUsgList') {
        IdHeader = {
          text: 'Vehicle Usage',
          value: 'value1'
        }
        this.title = 'Vehicle Usage Helplist'
        this.heading = 'Vehicle Usage List'
      } else if (this.helpListID === 'tariffList') {
        IdHeader = {
          text: 'Tariff Code',
          value: 'value1'
        }
        this.title = 'Tariff Helplist'
        this.heading = 'Tariffs List'
      } else {
        IdHeader = {
          text: 'Vehicle Group Code',
          value: 'value1'
        }
        this.title = 'Vehicle Group Helplist'
        this.heading = 'Vehicle Groups List'
      }
      const DescHeader = {
        text: 'Description',
        value: 'value2'
      }
      const ActionHeader = {
        text: 'Action',
        align: 'center',
        sortable: false,
        value: ''
      }
      this.headers.push(IdHeader)
      this.headers.push(DescHeader)
      this.headers.push(ActionHeader)
    },
    async doInit() {
      let HelpList = []
      if (this.helpListID === 'busClsGrpList') {
        HelpList = this.state.busClsGrpList
      } else if (this.helpListID === 'glanCodeList') {
        HelpList = this.state.glanCodeList
      } else if (this.helpListID === 'accumTypeList') {
        HelpList = this.state.accumTypeList
      } else if (this.helpListID === 'vehUsgList') {
        HelpList = this.state.vehUsgList
      } else if (this.helpListID === 'tariffList') {
        // HelpList = this.state.tariffList
        this.getTariffList()
      } else {
        HelpList = this.state.vehGrpList
      }
      this.items = []
      if (HelpList) {
        for (var i in HelpList) {
          const convertList = {
            value1: HelpList[i].value,
            value2: HelpList[i].secondaryValue
          }
          this.items.push(convertList)
        }
      }
    },
    doSelect(Id) {
      this.$emit('doAssign', Id)
      this.$emit('close')
    },
    async getTariffList() {
      const apiUrl = this.menu.getTariffLists
      if (apiUrl) {
        try {
          const expand = {
            busCls: this.busCls
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.items = []
            data['data']['tariffList'].map((result) => {
              const convertList = {
                value1: result.value,
                value2: result.secondaryValue
              }
              this.items.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.busClsParam.menu
    },
    state() {
      return this.$store.state.busClsParam
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
